import { render, staticRenderFns } from "./storeOrder.vue?vue&type=template&id=15240e9e&"
import script from "./storeOrder.vue?vue&type=script&lang=js&"
export * from "./storeOrder.vue?vue&type=script&lang=js&"
import style0 from "./storeOrder.vue?vue&type=style&index=0&id=15240e9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports